import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { InAppNotification, NotificationState } from '../types';
import { apiClient } from '../services/api';
import { hasAuthData } from '../utils/authHeaders';

// Лимит уведомлений для предотвращения переполнения localStorage в Telegram Mini App
const MAX_NOTIFICATIONS = 50;

const useInAppNotificationStore = create<NotificationState>()(
  persist(
    (set) => ({
      notifications: [],
      unreadCount: 0,
      isLoading: false,

      addNotification: (notification: InAppNotification) => {
        set((state) => ({
          // Добавляем новое уведомление и ограничиваем общее количество
          notifications: [notification, ...state.notifications].slice(0, MAX_NOTIFICATIONS),
        }));
      },

      markAsRead: (id: string) => {
        set((state) => ({
          notifications: state.notifications.map((n) =>
            n.id === id ? { ...n, isRead: true } : n
          ),
        }));
      },

      markAllAsRead: () => {
        set((state) => ({
          notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
        }));
      },

      removeNotification: (id: string) => {
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id),
        }));
      },

      loadNotifications: async () => {
        if (!hasAuthData()) {
          // Не логируем на публичных страницах - это нормальное поведение
          return;
        }

        set({ isLoading: true });

        try {
          const data = await apiClient.user.getUserNotifications();
          const notifications = data.notifications || [];
          // Ограничиваем количество загружаемых уведомлений
          set({ notifications: notifications.slice(0, MAX_NOTIFICATIONS) });
        } catch (error) {
          console.error('Error loading notifications:', error);
        } finally {
          set({ isLoading: false });
        }
      },

      clearNotifications: () => {
        set({ notifications: [] });
      },
    }),
    {
      name: 'in-app-notifications-storage',
      partialize: (state) => ({
        notifications: state.notifications,
      }),
    }
  )
);

export { useInAppNotificationStore };

